import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faCapsules } from '@fortawesome/pro-regular-svg-icons/faCapsules'
import { faFileMedical } from '@fortawesome/pro-regular-svg-icons/faFileMedical'
import { faUserDoctorMessage } from '@fortawesome/pro-regular-svg-icons/faUserDoctorMessage'
import { type TextColor } from '@lib/colors/colors'
import {
  isArrivoBioMdd,
  isOtsukaMdd,
} from '@modules/trials/helpers/isHardcodedTrial'
import type { ParsedTimelineAttribute } from './getTimelineValues'
import { TimelineSegments } from './TimelineSegments'

export const OneRowTimeline = ({
  iconColor = 'text-white',
  nctId,
  reporting,
  screening,
  treatment,
  variant = '3/3',
}: {
  iconColor?: TextColor
  nctId?: string
  reporting: ParsedTimelineAttribute
  screening: ParsedTimelineAttribute
  treatment: ParsedTimelineAttribute
  variant?: '3/3' | '1/3' | '2/3'
}) => {
  const secondItemColor = variant === '1/3' ? 'text-transparent' : 'text-white'
  const thirdItemColor = variant === '3/3' ? 'text-white' : 'text-transparent'
  const secondIconColor = variant === '1/3' ? 'text-transparent' : iconColor
  const thirdIconColor = variant === '3/3' ? iconColor : 'text-transparent'

  // Sponsor request
  const customTreatmentTitle =
    nctId && (isOtsukaMdd(nctId) || isArrivoBioMdd(nctId))
      ? 'Study Treatment'
      : 'Treatment'

  return (
    <div className='max-w-6xl'>
      <div className='mb-4 flex w-full justify-around'>
        <Icon className={iconColor} icon={faFileMedical} size='2x' />
        <Icon className={secondIconColor} icon={faCapsules} size='2x' />
        <Icon className={thirdIconColor} icon={faUserDoctorMessage} size='2x' />
      </div>
      <div className='relative'>
        <div className='absolute top-4 z-50 grid w-full grid-cols-3 gap-1 rounded-lg align-middle'>
          <div className='flex justify-between pl-2 pr-6 text-white'>
            <Text
              className='text-white'
              styleName='p-tiny'
              value={`Screening ~ ${screening.duration}`}
            />
            <Text
              className='text-white'
              styleName='p-tiny'
              value={screening.visitCount}
            />
          </div>
          <div className='flex justify-between pr-8'>
            <Text
              className={secondItemColor}
              styleName='p-tiny'
              value={`${customTreatmentTitle} ~ ${treatment.duration}`}
            />
            <Text
              className={secondItemColor}
              styleName='p-tiny'
              value={treatment.visitCount}
            />
          </div>
          <div className='flex justify-between pr-6'>
            <Text
              className={classMerge('line-clamp-1', thirdItemColor)}
              styleName='p-tiny'
              value={`Follow Up ~ ${reporting.duration}`}
            />
            <Text
              className={secondItemColor}
              styleName='p-tiny'
              value={reporting.visitCount}
            />
          </div>
        </div>
        <div className='w-full'>
          <TimelineSegments variant={variant} />
        </div>
      </div>
    </div>
  )
}
